import React from 'react';
import { observer, inject } from 'mobx-react';
import CollectionManager from '../common/CollectionManager';
import Form from './JobForm';
import Model from '../../models/Job';

export default inject('store')(observer(props => {
  const filterOptions = [
    { key: 'all', value: '', text: 'All'},
    { key: 'withJobNumber', value: 'withJobNumber', text: 'With Product Code'},
    { key: 'withoutJobNumber', value: 'withoutJobNumber', text: 'Withouout Product Code'},
  ]
  return <CollectionManager
    collectionName='jobs'
    ListComponent={props.ListComponent}
    FormComponent={Form}
    getItems={props.store.getJobs}
    getNewItem={() => Model.create()}
    searchPlaceholder='Search quotes...'
    addButtonText='New Quote'
    filterOptions={filterOptions}
    {...props}
  />
}))


// WEBPACK FOOTER //
// ./src/components/jobs/Jobs.js